
import apiHelpers from './apiHelpers.js';
import { mapCrudStoreGen } from '@/helpers/utils/storeHelpers.js';
let defaultForm = {};

let defaultFilters = {
  orderNumber: '',
  fulfillmentOrderId: '',
  projectId: '',
  storefrontIds: [],
  orderStatus: ['awaiting_shipment','on_hold','pending_fulfillment'],
  fulfillmentStatus: ['PendingFulfillment'],
  fulfilledByService: ['TPL', 'ConnectAPI'],
  shipToName: '',
  shipToStreet: '',
  shipToCountryCode: '',
  shipToState: '',
  orderDateStart: null,
  orderDateEnd: null
};

let genedStore = mapCrudStoreGen(defaultForm, defaultFilters, apiHelpers);

export default {
  namespaced: true,

  state: () => ({
    ...genedStore.state
  }),

  mutations: {
    ...genedStore.mutations
  },

  getters: {
    ...genedStore.getters
  },

  actions: {
    ...genedStore.actions
  },
};
